import type { OnyxAmount, OnyxAmountForm } from '../interfaces';

export class AmountHelper {
  public static add<T extends OnyxAmount | OnyxAmountForm>(a: T, b: T): T {
    if (a.currency !== b.currency) throw new Error(`Currencies don't match`);

    if (!('euroValue' in a) || !('euroValue' in b)) {
      return { ...a, value: a.value + b.value };
    }

    if (a.resultCurrency !== b.resultCurrency) {
      throw new Error(`Result currencies don't match`);
    }

    return {
      ...a,
      value: a.value + b.value,
      euroValue: a.euroValue + b.euroValue,
      defaultCurrencyValue: a.defaultCurrencyValue + b.defaultCurrencyValue,
      ...(a.resultCurrencyValue != null && {
        resultCurrencyValue: a.resultCurrencyValue + b.resultCurrencyValue,
      }),
    };
  }

  public static subtract<T extends OnyxAmount | OnyxAmountForm>(a: T, b: T): T {
    if (a.currency !== b.currency) throw new Error(`Currencies don't match`);

    if (!('euroValue' in a) || !('euroValue' in b)) {
      return { ...a, value: a.value - b.value };
    }

    if (a.resultCurrency !== b.resultCurrency) {
      throw new Error(`Result currencies don't match`);
    }

    return {
      ...a,
      value: a.value - b.value,
      euroValue: a.euroValue - b.euroValue,
      defaultCurrencyValue: a.defaultCurrencyValue - b.defaultCurrencyValue,
      ...(a.resultCurrencyValue != null && {
        resultCurrencyValue: a.resultCurrencyValue - b.resultCurrencyValue,
      }),
    };
  }

  public static multiply<T extends OnyxAmount | OnyxAmountForm>(
    a: T,
    b: number,
  ): T {
    if (!('euroValue' in a)) return { ...a, value: a.value * b };

    return {
      ...a,
      value: a.value * b,
      euroValue: a.euroValue * b,
      defaultCurrencyValue: a.defaultCurrencyValue * b,
      ...(a.resultCurrencyValue != null && {
        resultCurrencyValue: a.resultCurrencyValue * b,
      }),
    };
  }

  public static divide<T extends OnyxAmount | OnyxAmountForm>(
    a: T,
    b: number,
  ): T {
    if (!('euroValue' in a)) return { ...a, value: a.value / b };

    return {
      ...a,
      value: a.value / b,
      euroValue: a.euroValue / b,
      defaultCurrencyValue: a.defaultCurrencyValue / b,
      ...(a.resultCurrencyValue != null && {
        resultCurrencyValue: a.resultCurrencyValue / b,
      }),
    };
  }
}
